module.exports = __webpack_public_path__ + "static/mobile-hero-2b173acd0bfbeb5e460f7a324bc5827d.jpg";